/**
 * @generated SignedSource<<f2eeeaafd7f762fab31187f0de7c3ded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type booksLineDetailPageTxns_Query$variables = {
  booksLineCode?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
};
export type booksLineDetailPageTxns_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
  }>;
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly transactions: {
    readonly limit: number;
    readonly totalAmount: number;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly category: string | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterparty: {
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly md5: string;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type booksLineDetailPageTxns_Query = {
  response: booksLineDetailPageTxns_Query$data;
  variables: booksLineDetailPageTxns_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "booksLineCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "perspectiveId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortDirection"
  }
],
v1 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "booksLineCode",
    "variableName": "booksLineCode"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v18 = [
  (v6/*: any*/),
  (v16/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": [
    (v1/*: any*/)
  ],
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNatures",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "booksLineDetailPageTxns_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "booksLineDetailPageTxns_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v19/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ]
  },
  "params": {
    "cacheID": "2d1206b3c668e161ca2d60ff7f174397",
    "id": null,
    "metadata": {},
    "name": "booksLineDetailPageTxns_Query",
    "operationKind": "query",
    "text": "query booksLineDetailPageTxns_Query(\n  $booksLineCode: String\n  $perspectiveId: ID\n  $sort: TxnSortEnum\n  $sortDirection: String\n) {\n  transactions(booksLineCode: $booksLineCode, perspectiveId: $perspectiveId, sort: $sort, sortDirection: $sortDirection) {\n    totalCount\n    totalAmount\n    limit\n    txns {\n      txn {\n        id\n      }\n      md5\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      classification\n      counterparty {\n        name\n        id\n      }\n      category\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n  allStakeholders {\n    id\n    name\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n  }\n  expenseNatures(perspectiveId: $perspectiveId) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "97509b20b8a7ec434ab8449976deb2f9";

export default node;
